import { render, staticRenderFns } from "./CustomBtn.vue?vue&type=template&id=6a79f3f5&scoped=true"
import script from "./CustomBtn.vue?vue&type=script&lang=js"
export * from "./CustomBtn.vue?vue&type=script&lang=js"
import style0 from "./CustomBtn.vue?vue&type=style&index=0&id=6a79f3f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a79f3f5",
  null
  
)

export default component.exports